import { lazyAppContext } from '../lazy';
export class TTLStorage {
    constructor(key, expireTime) {
        this.key = key;
        this.expireTime = expireTime;
        this.context = lazyAppContext('TTLStorage');
        this.timestamp = 0;
    }
    async init(context) {
        this.context.set(context);
        this.timestamp = this.context.value.storage.get(this.key, Number) ?? 0;
    }
    reset() {
        this.timestamp = Date.now();
        this.context.value.storage.set(this.key, this.timestamp);
    }
    isExpired() {
        return Date.now() - this.timestamp > this.expireTime;
    }
}
//# sourceMappingURL=ttl.storage.js.map